export default __webpack_public_path__ + "static/media/icon-flows.bc63e89d.svg";